import React, { useRef } from "react";
import { triggerAnalyticsEvent } from "../../helpers";

type Props = {
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  classList?: string;
  visible?: boolean;
  children?: React.ReactNode;
  clickEventActionKey?: string;
};

export function TourUploadButton({
  handleFileChange,
  clickEventActionKey = "photo_upload_click",
  children,
  classList,
  visible = true
}: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const labelRef = useRef<HTMLLabelElement>(null);

  if (!visible) {
    return null;
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLLabelElement>) => {
    if (event.key === "Enter") {
      inputRef.current?.click();
      reportAnalytics();
    } else if (event.key === " ") {
      event.preventDefault();
      inputRef.current?.click();
      reportAnalytics();
    }
  };

  const reportAnalytics = () => {
    const eventButtonText = labelRef.current?.innerText || "";

    triggerAnalyticsEvent("flex_checkout_photo_upload_click", {
      event_action: clickEventActionKey,
      event_category: "flex_photo_upload",
      event_label: eventButtonText
    });
  };

  return (
    <div className="upload-button">
      <label
        ref={labelRef}
        className={`${classList}`}
        htmlFor="upload_button"
        tabIndex={0}
        onKeyDown={handleKeyPress}
        onClick={reportAnalytics}>
        {children}
      </label>
      <input
        ref={inputRef}
        id="upload_button"
        type="file"
        accept="image/jpeg"
        onChange={handleFileChange}
        className="hidden"
      />
    </div>
  );
}

export default TourUploadButton;
